import { useEffect, useState } from "react";
import { IVehicle } from "../../../../types/vehicle.type";
import VehicleMaintenanceCard from "./VehicleMaintenanceCard";
import { IMaintenanceVisualRecord } from "../../../../types/maintenance-visual-record.type";

import "./VehicleMaintenanceGallery.scss";
import { getImageMaintenanceVisualRecord } from "../../../../common/services/maintenance.api";
import { IMaintenance } from "@/types/maintenance.type";

type Props = {
  data: IVehicle;
}

export default function VehicleMaintenanceGallery(props: Props) {
  const vehiclesId = props.data._id;
  const [vehicleData, setVehicleData] = useState<IMaintenanceVisualRecord[]>([]);
  const [maintenances, setMaintenances] = useState<IMaintenance[]>([]);
  const [hasUpdated, setHasUpdated] = useState(false);

  useEffect(() => {
    async function loadVehicleData(vehicleId: string) {
      if (!vehicleId) return;

      const { data, ok } = await getImageMaintenanceVisualRecord(vehicleId);

      if (ok) {
        const sortedData = data.maintenancesVisualRecords.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        setVehicleData(sortedData as IMaintenanceVisualRecord[]);
        setMaintenances(data.maintenances);
      }
    }

    setVehicleData([]);

    if (vehiclesId) loadVehicleData(vehiclesId);

  }, [hasUpdated, vehiclesId]);


  return (
    <div className="tabs-border-line">
      <section className="tabs-item-style">
        <h2 className="font-semibold text-2xl col-span-2 text-center">Histórico de Manutenções do Veículo</h2>
        <div className="flex flex-row flex-wrap w-full pt-8 gap-4 align-items-center justify-center">
          {vehicleData.map((record, index) => (
            <VehicleMaintenanceCard
              key={record._id}
              vehicleRecord={record}
              isFirstRecord={index === 0}
              setHasUpdated={setHasUpdated}
              maintenances={maintenances}
            />
          ))}
        </div>

      </section >
    </div >
  );
}
